import PropertyAdForm from "../../../../components/forms/propertyAdform";
import { useState, useEffect } from "react";
import { useCreatePropertyMutation } from "../../../../features/property/propertyApiSlice";
import { useLazyGetShopConsumerCategoriesQuery } from "../../../../features/shop/shopApiSlice";
import { SuccessNotify, FailedNotify } from "../../../../constants/tostify";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import Loader from "../../../../components/Loader";
import { publishImage } from "../../../../helpers/imageupload";
import { useDropzone } from "react-dropzone";
import { decodeId } from "../../../../utils/idObfuscator";
import { useGetCompanyByIdQuery } from "../../../../features/user/userApiSlice";
import { useGetShopByIdQuery } from "../../../../features/shop/shopApiSlice";

const PostBusinessAd = () => {
  const { id } = useParams();
  const { name } = useSelector((state) => state.user);
  const [isloading, setIsloading] = useState(false);
  const navigate = useNavigate();
  const [displayimg, setDisplayimg] = useState();
  const [shopCategory, setShopCategory] = useState();
  const [shopCategorytwo, setShopCategorytwo] = useState();
  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [createProperty] = useCreatePropertyMutation();
  const [getShopConsumerCategories] = useLazyGetShopConsumerCategoriesQuery();

  const cleanId = decodeId(id) || id || "";
  const { data: companyRes } = useGetCompanyByIdQuery(cleanId, {
    skip: !cleanId,
  });
  const { data: shopRes } = useGetShopByIdQuery(cleanId, {
    skip: !cleanId,
  });
  const company = companyRes?.data?.Company || shopRes?.data?.Shop;

  const [data, setData] = useState({
    category: "",
    subCategoryid: "",
  });

  const Handledata = (e) => {
    const raw = e.target.value || "";
    const dot = raw.indexOf(".");
    let idPart = raw;
    let namePart = "";
    if (dot !== -1) {
      idPart = raw.slice(0, dot);
      namePart = raw.slice(dot + 1);
    }
    setData((prevState) => ({
      ...prevState,
      [e.target.name]: [idPart, namePart],
    }));
  };

  const categoryName = data?.category[1];
  const categoryid = data.category[0];
  const categoryNametwo = data?.subCategoryid[1];
  const categoryidtwo = data.subCategoryid[0];

  const onDrop = async (acceptedFiles) => {
    try {
      setIsUploading(true);
      setUploadProgress(0);

      const abc = await publishImage(acceptedFiles, (percent) => {
        setUploadProgress(percent);
      });
      setPropertyadd((propertyadd) => ({
        ...propertyadd,
        image: abc,
      }));

      setDisplayimg(abc);
    } catch (error) {
      FailedNotify("Failed! Try Again");
    } finally {
      setIsUploading(false);
      setUploadProgress(0);
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*",
    onDrop,
  });

  const Firstcategory = () => {
    getShopConsumerCategories({ type: "property", parentCategory: "" })
      .unwrap()
      .then(async (response) => {
        if (response?.success) {
          setShopCategory(response?.data?.Category);
        }
      })
      .catch((error) => {
        console.log("servicesCategories", error);
      });
  };

  const Mydata = () => {
    if (!categoryName) return;
    getShopConsumerCategories({
      type: "property",
      parentCategory: categoryName,
    })
      .unwrap()
      .then(async (response) => {
        console.log("jksahdf", response);
        if (response?.success) {
          setShopCategorytwo(response?.data?.Category);
        }
      })
      .catch((error) => {
        console.log("servicesCategories", error);
      });
  };

  const [propertyadd, setPropertyadd] = useState({
    companyid: id,
    userid: name?._id || "",
    plottype: "",
    country: "",
    categoryid: "",
    category: "",
    subCategoryid: "",
    subCategory: "",
    currency: "",
    city: "",
    state: "",
    area: "",
    contactnumber: "",
    email: "",
    price: "",
    saletype: "",
    description: "",
    image: [],
    status: true,
    businessType: "businessPropertyCompany",
  });

  useEffect(() => {
    setPropertyadd((propertyadd) => ({
      ...propertyadd,
      categoryid: categoryid,
      category: categoryName,
      subCategoryid: categoryidtwo,
      subCategory: categoryNametwo,
    }));
  }, [categoryid, categoryName, categoryidtwo, categoryNametwo]);

  useEffect(() => {
    const resolvedUserId = company?.userid?._id || company?.userid || name?._id || "";
    const resolvedCompanyId = company?._id || cleanId || id || "";
    if (!resolvedUserId && !resolvedCompanyId) return;

    // Load country, state, city from backend API (company, shop, or user profile)
    const defaultCountry =
      company?.resolvedCountry ||
      company?.country ||
      company?.userid?.address?.country ||
      company?.userid?.country ||
      name?.address?.country ||
      name?.country ||
      "";
    const defaultState =
      company?.resolvedRegion ||
      company?.state ||
      company?.userid?.address?.state ||
      company?.userid?.state ||
      name?.address?.state ||
      name?.state ||
      "";
    const defaultCity =
      company?.resolvedCity ||
      company?.city ||
      company?.userid?.address?.city ||
      company?.userid?.city ||
      name?.address?.city ||
      name?.city ||
      name?.MCity ||
      "";

    setPropertyadd((prev) => ({
      ...prev,
      userid: resolvedUserId || prev.userid,
      companyid: resolvedCompanyId || prev.companyid,
      country: prev.country || defaultCountry,
      state: prev.state || defaultState,
      city: prev.city || defaultCity,
    }));
  }, [company, name, cleanId, id]);

  const formSubmit = (e) => {
    setIsloading(true);
    e.preventDefault();
    const payload = {
      ...propertyadd,
      userid: propertyadd.userid || company?.userid?._id || company?.userid || name?._id,
      companyid: propertyadd.companyid || company?._id || cleanId || id,
      country: propertyadd.country,
      state: propertyadd.state,
      city: propertyadd.city,
    };
    createProperty(payload)
      .unwrap()
      .then(async (response) => {
        console.log("propertyadd", response);

        if (response?.success) {
          setIsloading(false);
          setTimeout(() => {
            SuccessNotify("Add Posted SuccesFully...");
            navigate(`/Sale-Bussines-Property/${id}`);
          }, 1000);
        }
      })
      .catch((error) => {
        setIsloading(false);
        FailedNotify("Failed to Post Try Again!");
      });
  };

  if (isloading) {
    return <Loader heightsetting="screenHeight" />;
  }

  return (
    <div>
      <PropertyAdForm
        title="Create Business Property Category,Location,Price,Description"
        butn="Post"
        navigateTo="/Sale-Bussines-Property"
        back="/Sale-Bussines-Property"
        propertyadd={propertyadd}
        setPropertyadd={setPropertyadd}
        handlerFunction={formSubmit}
        shopCategory={shopCategory}
        shopCategorytwo={shopCategorytwo}
        Mydata={Mydata}
        Handledata={Handledata}
        Firstcategory={Firstcategory}
        id={id}
        getInputProps={getInputProps}
        getRootProps={getRootProps}
        displayimg={displayimg}
        setDisplayimg={setDisplayimg}
        isUploading={isUploading}
        uploadProgress={uploadProgress}
      />
    </div>
  );
};
export default PostBusinessAd;
